<template>
    <Head v-if="!loading" :title="__('Test Case')" />
    <div class="task__details">
        <div class="wrapper" id="modal">
            <div role="alert" class="container max-w-3xl">
                <div v-if="loading" class="content">
                    <div role="status" class="td__loader">
                        <div class="__f"><div><div class="i__1" /><div class="i__2" /></div><div class="i__r" /></div>
                        <div class="__f"><div><div class="i__1" /><div class="i__2" /></div><div class="i__r" /></div>
                        <div class="__f"><div><div class="i__1" /><div class="i__2" /></div><div class="i__r" /></div>
                        <div class="__f"><div><div class="i__1" /><div class="i__2" /></div><div class="i__r" /></div>
                        <div class="__f"><div><div class="i__1" /><div class="i__2" /></div><div class="i__r" /></div>
                        <div class="__f"><div><div class="i__1" /><div class="i__2" /></div><div class="i__r" /></div>
                        <div class="__f"><div><div class="i__1" /><div class="i__2" /></div></div>
                        <div class="__f"><div><div class="i__1" /><div class="i__2" /></div></div>
                        <div class="__f"><div><div class="i__1" /><div class="i__2" /></div></div>
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
                <div v-else>
                    <div class="content">
                        
                        <div class="close_area">
                            <div class="wrap">
                                <span @click="$emit('closeModal', true)" class="close__b">
                                    <icon class="h-6 w-6" name="close" />
                                </span>
                            </div>
                        </div>
                      
                        <div class="m__body">
                            <main class="main">
                                <div class="flex mb-2">
                                    <label class="w-full flex flex-col text-left">
                                        <div class="mb-2">{{ __('Testcase name') }} *</div>
                                        <input v-model="testCase.name" class="border rounded p-2 text-sm bg-white w-full" type="text" required="" aria-required="true" autocomplete="off" autofocus>
                                        <div v-if="errors?.name" class="my-2 text-red-500">{{ errors?.name[0] }}</div>
                                    </label>
                                </div>
                                <div class="flex mb-2">
                                    <label class="w-full flex flex-col text-left">
                                        <div class="mb-2">{{ __('Objective') }}</div>
                                        <quill-editor ref="objective" v-model:content="testCase.objective" class="task__description" :options="editorOptions" contentType="html" theme="snow" />
                                    </label>
                                </div>
                                <div class="flex mb-2">
                                    <label class="w-full flex flex-col text-left">
                                        <div class="mb-2">{{ __('Precondition') }}</div>
                                        <quill-editor ref="precondition" v-model:content="testCase.precondition" class="task__description" :options="editorOptions" contentType="html" theme="snow" />
                                    </label>
                                </div>
                                <div class="flex flex-row mb-2 gap-2">
                                    <label class="w-full flex flex-col text-left">
                                        <div class="mb-2">{{ __('Status') }} *</div>
                                        <select v-model="testCase.status" class="border rounded p-2 text-sm bg-white w-full">
                                            <option value="draft">{{ __('Draft') }}</option>
                                            <option value="approved">{{ __('Approved') }}</option>
                                        </select>
                                    </label>
                                    <label class="w-full flex flex-col text-left">
                                        <div class="mb-2">{{ __('Priority') }} *</div>
                                        <select v-model="testCase.priority" class="border rounded p-2 text-sm bg-white w-full">
                                            <option value="high">{{ __('High') }}</option>
                                            <option value="medium">{{ __('Medium') }}</option>
                                            <option value="low">{{ __('Low') }}</option>
                                        </select>
                                    </label>
                                </div>
                                <div class="flex flex-row my-3 gap-2">
                                    <label class="w-full flex flex-col text-left">
                                        <div class="mb-2">{{ __('Estimated run time') }}</div>
                                        <input v-model="testCase.estimated_time" class="border rounded p-2 text-sm bg-white w-full" type="string" placeholder="hh:mm" autocomplete="off">
                                        <div v-if="errors?.estimated_time" class="my-2 text-red-500">{{ errors?.estimated_time[0] }}</div>
                                    </label>
                                    <label class="w-full flex flex-col text-left">
                                        <div class="mb-2">{{ __('Assigned To') }} *</div>
                                        <select v-model="testCase.assigned_user" class="border rounded p-2 text-sm bg-white w-full">
                                            <option v-for="(member, mi) in members" :key="mi" :value="member.id">
                                                {{ member.name }}
                                            </option>
                                        </select>
                                    </label>
                                </div>
                                <div class="flex justify-end">
                                    <button class="bg-indigo-600 text-white p-[9px] rounded disabled:opacity-50" @click="createTestCase()">{{ isUpdate ? 'Update' : 'Create' }}</button>
                                </div>
                            </main>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import Loader from '@/Shared/Loader'
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import moment from 'moment'
import 'moment-duration-format';
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import axios from 'axios'

export default {
    props: {
        project: Object,
        isUpdate: Boolean,
        id: Number,
        members: Object
    },
    emits: {closeModal: null},
    data() {
        return {
            errors: '',
            showEditor: '',
            loading: false,
            projects: null,
            label: {},
            task: {},
            testCase: {
                name: '',
                objective: '',
                precondition: '',
                status: 'draft',
                priority: 'medium',
            },
            colors: [
                {'name': 'subtle green', 'color': '#baf3db'}, {'name': 'subtle yellow', 'color': '#f8e6a0'}, {'name': 'subtle orange', 'color': '#ffe2bd'}, {'name': 'subtle red', 'color': '#ffd2cc'}, {'name': 'subtle purple', 'color': '#dfd8fd'},
                {'name': 'green', 'color': '#4bce97'}, {'name': 'yellow', 'color': '#e2b203'}, {'name': 'orange', 'color': '#faa53d'}, {'name': 'red', 'color': '#f87462'}, {'name': 'purple', 'color': '#9f8fef'},
                {'name': 'bold green', 'color': '#1f845a'}, {'name': 'bold yellow', 'color': '#946f00'}, {'name': 'bold orange', 'color': '#b65c02'}, {'name': 'bold red', 'color': '#ca3521'}, {'name': 'bold purple', 'color': '#6e5dc6'},
                {'name': 'subtle blue', 'color': '#cce0ff'}, {'name': 'subtle sky', 'color': '#c1f0f5'}, {'name': 'subtle lime', 'color': '#D3F1A7'}, {'name': 'subtle pink', 'color': '#fdd0ec'}, {'name': 'subtle black', 'color': '#dcdfe4'},
                {'name': 'blue', 'color': '#579dff'}, {'name': 'sky', 'color': '#60c6d2'}, {'name': 'lime', 'color': '#94c748'}, {'name': 'pink', 'color': '#e774bb'}, {'name': 'black', 'color': '#8590a2'},
                {'name': 'bold blue', 'color': '#0c66e4'}, {'name': 'bold sky', 'color': '#1d7f8c'}, {'name': 'bold lime', 'color': '#5b7f24'}, {'name': 'bold pink', 'color': '#ae4787'}, {'name': 'bold black', 'color': '#626f86'},
            ],
            editorOptions: {
                modules: {
                    toolbar: {
                        container: [
                            { 'header': [1, 2, 3, 4, 5, 6, false] },
                            'bold', 'italic', 'underline', { 'list': 'bullet' }, { 'list': 'ordered'},
                            'align', 'clean',
                            'blockquote', 'code-block',
                            // 'image'
                        ],
                        // handlers: { 'image': this.imageButtonClickHandler }
                    },
                    // imageDrop: true,
                }
            }
        }
    },
    components: {
        Icon, Loader, Link, Datepicker, QuillEditor, Head
    },
    computed: {

    },
    created() {
        if(this.isUpdate) {
            this.getTestCase(this.id)
        }
        this.testCase.assigned_user = this.$page.props.auth.user.id;
    },
    methods: {
        onEditorReady(editor){},
        async getTestCase(id){
            const testCaseResponse = await axios.get(this.route('json.test_case.get', {uid:id}));
            this.testCase = testCaseResponse.data
            this.testCase.status = testCaseResponse.data.status === 0 ? 'draft' : 'approved';
            this.testCase.priority = testCaseResponse.data.priority === 0 ? 'low' : testCaseResponse.data.priority === 1 ? 'medium' : 'high';
        },
        createTestCase() {
            const testCase = { ...this.testCase, project_id: this.project.id };
            if(this.isUpdate) {
                testCase.id = this.id
            }
            axios.post(this.route('json.testcase.create'), testCase).then((response) => {
                if(response.data){
                    this.$inertia.get(this.route('projects.view.test_cases', this.project.slug || this.project.id))
                    this.$emit('closeModal', true);
                }
            }).catch((error) => {
                this.errors = error.response.data.errors;
                
                console.log(this.errors.name)
            });
        }
    },
    name: "add-test-case"
};
</script>
